<script lang="ts">
	import { onDestroy } from 'svelte';
	import { loadingStore } from '../../store/loader';

	let loading = false;

	const unsubscribe = loadingStore.subscribe(value => {
		loading = value;
	});

	$: {
		const l = $loadingStore;
		// console.log(l);
	}
	onDestroy(unsubscribe);
</script>

{#if loading}
	<div class="loading-cover fl j-c">
		<span class="me-4">Loading...</span>
		<div class="loading loading-lg" />
	</div>
{/if}

<style lang="scss" scoped>
	.loading-cover {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba($color: #fff, $alpha: 0.8);
		z-index: 1;

		span {
			font-size: 1.3rem;
			font-weight: bold;
			// color: #222;
		}
	}
</style>
